module.exports = __webpack_public_path__ + "static/media/Trust-Badge-2.a9417a1d.png";